// extracted by mini-css-extract-plugin
module.exports = {"container":"stockists-module--container--VUnNI","introduction":"stockists-module--introduction--3PNsA","mapArea":"stockists-module--map-area--3xgxp"};